/**
 * Configuration d'environnement — développement distant (dev).
 * Utilise les backends dev-* sur le domaine freyr-app.com.
 */
export const environment = {
  production: false,
  /**
   * true : seule la page "Bientôt disponible" (/coming-soon) est accessible.
   * false : le site est entièrement inaccessible, toutes les routes redirigent vers /unavailable.
   */
  comingSoon: false,
  /** URL de l'API principale (gateway / BFF) côté environnement dev */
  apiUrl: 'https://dev-api.freyr-app.com/api',
  /** URL du service d'authentification (dev) pour login Twitch et callback */
  securityApiUrl: 'https://dev-id.freyr-app.com',
  adminAppUrl: 'https://dev-admin.freyr-app.com',
  /** URL du bot (intégrations Twitch/Discord/Spotify) sur l'environnement dev */
  botApiUrl: 'https://dev-bot.freyr-app.com',
  /** URL du service batch (statut stream EventSub + SSE). Vide = même origine que l'API : les appels vont vers dev-api.freyr-app.com/batch/... (le gateway doit router /batch vers le service batch). */
  batchApiUrl: ''
};

